
import cardBg from '../../assets/images/cardbg.svg'
import SalPageLayout from './SalPageLayout';
import SaleCta from './components/SaleCta';
// import TokenSaleCharts from './components/TokenSaleCharts/TokenSaleCharts';
import TokenSaleHeader from './components/TokenSaleHeader/TokenSaleHeader';
import { Suspense } from 'react';
import AppLoader from '../../components/AppLoader/AppLoader';
import { lazy } from 'react';
import { useGetIco } from './hooks/useGetIco';

const TokenSaleRightSideBar = lazy(() => import('./components/TokenSaleRightSideBar.jsx/TokenSaleRightSideBar'))
const Contributors = lazy(() => import('./components/Contributors/Contributors'))
const TokenSaleMainInfo = lazy(() => import('./components/TokenSaleMainInfo/TokenSaleMainInfo'))

export default function SalePage() {

    // fetches ICO with contributors
const status = useGetIco()

    return (
        <>
            <SalPageLayout>
                <SaleCta />
                <div className='flex-col flex lg:flex-row gap-5 h-full w-full'>
                    <div className='grid  w-full'>
                        <div className='w-full h-max flex gap-5  flex-col   rounded  ' >
                            {/* <TokenSaleHeader /> */}
                            <Suspense fallback={
                                <div className='!w-full !h-full  shadow-xl  rounded-lg border-yellow-500/10 border    bg-black/80 backdrop-blur p-5 '>
                                    <AppLoader />
                                </div>}>
                            <TokenSaleMainInfo />
                            </Suspense>
                            <Suspense fallback={
                                <div className='!w-full !h-full  shadow-xl  rounded-lg border-yellow-500/10 border    bg-black/80 backdrop-blur p-5 '>
                                    <AppLoader />
                                </div>}>
                                <Contributors />
                            </Suspense>
                            {/* <TokenSaleCharts /> */}
                        </div>
                    </div>
                    <Suspense fallback={
                        <div className='w-1/3 h-max border-yellow-500/10 border rounded bg-black/80 backdrop-blur px-5 py-5 space-y-5'>
                            <AppLoader />
                        </div>}>
                        <TokenSaleRightSideBar />
                    </Suspense>
                </div>
            </SalPageLayout>
        </>
    )
}